// Centralized i18n strings for EN/ES.
const dict = {
  en: {
    redApoyo: {
      navLabel: "RED Online",
      heroEyebrow: "Virtual support network",
      heroTitle: "Free virtual appointments with trusted professionals",
      heroSub: "Doctors, lawyers, advisors and other professionals donate their time to help our community. Browse availability, pick a slot and book in seconds.",
      filterCategory: "Specialty",
      filterCity: "City (optional)",
      filterFrom: "From date",
      filterTo: "To date",
      noResults: "No open slots match your filters. Try widening the date range or removing filters.",
      bookBtn: "Book this slot",
      durationLabel: "Duration",
      withLabel: "With",
      topicLabel: "Topic",
      availableLabel: "available",
      professionalsCountLabel: "professionals",
      availableSlotsLabel: "open slots",
      // Public impact strip on the landing
      impactEyebrow: "Real impact, real numbers",
      impactTitle: "Our community in action",
      impactSubtitle: "Every booked session is a professional donating their time. Here's the impact so far.",
      impactHours: "hours donated",
      impactPeople: "people helped",
      impactPros: "active professionals",
      impactOpen: "open slots now",
      impactCta: "Book your free session",
      noRatingsYet: "No reviews yet",
      viewFullProfile: "View full profile",
      // Booking modal
      bookTitle: "Book this appointment",
      bookSub: "Tell {pro} briefly what you need. They'll receive an email with the details.",
      topicPlaceholder: "Short topic (e.g. 'I need help with my visa application')",
      notesLabel: "Notes (optional)",
      notesPlaceholder: "Any context that helps the professional prepare…",
      confirmBook: "Confirm booking",
      booking: "Booking…",
      bookSuccess: "Appointment confirmed! Check your email for details.",
      // Manage availability (professional dashboard)
      availabilityTitle: "My virtual availability",
      availabilitySub: "Open time slots so community members can book a virtual session with you. Free of charge — you're donating your time.",
      addSlotBtn: "Add slot",
      slotDate: "Date & start time",
      slotDuration: "Duration (min)",
      slotTopicHint: "Topic / specialty (optional)",
      slotTopicHintPlaceholder: "e.g. Immigration · Tax filing · Mental health…",
      saveSlot: "Save",
      cancelSlot: "Cancel",
      noSlots: "You haven't opened any slots yet.",
      emptyHowItWorks: "How it works",
      emptyTitle: "Open your first slots in 3 steps",
      emptySub: "Community patients will be able to book directly on the slots you publish.",
      emptyStep1Title: "1. Publish a slot",
      emptyStep1Desc: "Pick date, time and duration (15 to 120 min).",
      emptyStep2Title: "2. Receive the booking",
      emptyStep2Desc: "A patient books and you'll see their name and reason here.",
      emptyStep3Title: "3. Attend the session",
      emptyStep3Desc: "Contact the patient at the agreed time (Zoom, phone, etc).",
      emptyAddFirst: "Add my first slot",
      emptyPreviewHint: "Patients will see your agenda on the RED Online page.",
      presetIn2h: "Today +2h",
      presetTomorrow: "Tomorrow 9:00",
      presetNext3d: "In 3 days 15:00",
      statusOpen: "Open",
      statusBooked: "Booked",
      removeBtn: "Remove",
      // My bookings
      myBookingsTitle: "My booked sessions",
      myBookingsEmpty: "You haven't booked any sessions yet.",
      cancelBooking: "Cancel",
      // Admin
      adminTotalHours: "Total hours donated",
      adminUsersHelped: "Users helped",
      adminBookings: "Sessions booked",
      adminTopPros: "Top professionals",
      // Join CTA banner (above the listings on /red-apoyo)
      joinEyebrow: "Are you a professional?",
      joinTitleGuest: "Join the RED Online and donate your time",
      joinSubGuest: "Doctors, lawyers, coaches and advisors: create your free account and start opening virtual slots in minutes.",
      joinCtaGuest: "Create my account",
      joinTitleMember: "Activate your professional profile",
      joinSubMember: "Create a professional profile to open your agenda and receive bookings.",
      joinCtaMember: "Create professional profile",
      joinTitlePro: "Manage your RED Online agenda",
      joinSubPro: "Open new slots and review your bookings in one place.",
      joinCtaPro: "Go to my agenda",
      joinSecondary: "Learn how it works",
    },
    nav: {
      home: "Home", directory: "Directory", events: "Events", about: "About us", contact: "Contact",
      login: "Log in", register: "Join the RED",
      dashboard: "My profile", admin: "Admin", logout: "Log out",
    },
    topbar: {
      tagline: "Be part of a movement that connects hearts, resources, and solutions.",
      join: "Join the RED",
    },
    hero: {
      eyebrow: "Together, we transform.",
      title: "RAS: The first network that connects real services with real people.",
      taglineParts: ["Moving Hearts.", "Uniting Efforts.", "Real Impact."],
      subtitle: "One network that connects everything.",
      ctaPrimary: "Join the RED — it's free",
      ctaSecondary: "Browse the directory",
      trustLine: "+600 active professionals in the RED",
      membersLabel: "members registered in the RED",
      membersLabelLoading: "A growing community",
      businessesLabel: "local businesses & ventures",
      stats: [
        { v: "500+", l: "Network members" },
        { v: "12", l: "Industries" },
        { v: "100%", l: "Bilingual support" },
      ],
    },
    services: {
      title: "Four ways to connect, one network.",
      subtitle: "We don't compete — we connect and coordinate solutions.",
      items: [
        { t: "Community Members", d: "Finding trusted local services." },
        { t: "Entrepreneurs", d: "Creating opportunities & finding more users." },
        { t: "Professionals", d: "Doctors, lawyers, advisors building trust." },
        { t: "Organizations & Churches", d: "Serving the community." },
      ],
    },
    why: {
      eyebrow: "Why join the RED?",
      title: "Find more users. Grow with the community.",
      subtitle: "Whether you're a customer or a business owner — registering connects you to trusted local services and opportunities.",
      bullets: [
        { t: "Free public profile", d: "Showcase your business with photo, story, contact and social links." },
        { t: "Local discovery", d: "Customers searching for your category and city find you first." },
        { t: "Community trust", d: "The RED stamp signals a vetted, values-aligned business." },
        { t: "Bilingual reach", d: "Reach English & Spanish-speaking users in one place." },
      ],
      cta: "Create my free account",
    },
    directoryPreview: {
      eyebrow: "Featured businesses",
      title: "Discover entrepreneurs in the network.",
      seeAll: "See full directory",
    },
    directory: {
      title: "Entrepreneurs & Businesses",
      subtitle: "Explore the directory and connect with local entrepreneurs and businesses.",
      searchPlaceholder: "Search by name, city, keyword…",
      all: "All",
      results: "results",
      empty: "No businesses found. Try a different search.",
      view: "View profile",
      tabEntrepreneurs: "Entrepreneurs",
      tabProfessionals: "Professionals",
      emptyProfessionals: "No professionals found. Try a different search.",
      entrepreneursAndBusiness: "Entrepreneurs & Businesses",
      lookingForPros: "Looking for a professional? Go to RED Online",
    },
    paywall: {
      eyebrow: "Members only",
      title: "Services Directory",
      subtitle: "Explore the directory and connect now.",
      invite: "To find what you need, when you need it,",
      inviteCta: "just register.",
      whyTitle: "Why we ask?",
      whyText: "We're a trusted community. Members register so businesses know who's reaching out.",
      asClient: "Register as a user",
      asClientDesc: "I want to find services & businesses I can trust.",
      asEntrepreneur: "Register my business or profession",
      asEntrepreneurDesc: "I want to register my business and find more users.",
      registerCta: "Register free",
      already: "Already a member?",
      loginLink: "Log in",
    },
    about: {
      eyebrow: "About Us",
      title: "Who we are",
      body: "The Network of Love and Solidarity unites media outlets, nonprofits, churches, entrepreneurs, and leaders to generate real and sustainable impact. We do not compete — we connect and coordinate solutions.",
      mission: { t: "Mission", d: "Connect key community actors to link needs with resources, strengthen social initiatives, and generate sustainable impact through unity, transparency, and collective commitment." },
      vision: { t: "Vision", d: "Become a model of community collaboration that inspires effective unity and sustainable transformation — proof that when a community walks together, change is inevitable." },
    },
    contact: {
      eyebrow: "Contact", title: "How can we help?",
      subtitle: "Have a question? Fill out the form and we'll get back to you.",
      name: "Full name", email: "Email", role: "Type of participation",
      contribution: "How would you like to contribute?", message: "Message",
      send: "Send message", sent: "Message sent. We'll be in touch!",
      roles: ["Nonprofit organization", "Media", "Entrepreneur", "Church", "Volunteer", "Community leader"],
      contributions: ["Volunteering", "Strategic alliance", "Donations or resources", "Community support"],
      address: "Address", hours: "Working hours", contacts: "Contacts",
    },
    footer: {
      tag: "We do not compete — we connect and coordinate solutions.",
      links: "Useful links", services: "Services", contactNow: "Contact now",
      rights: "Designed Team UMATP",
    },
    otp: {
      createWith: "Create your account with",
      emailOpt: "Email",
      phoneOpt: "Phone",
      title: "Verify your phone",
      sub: "We sent a 6-digit code by SMS to",
      codeLabel: "Verification code",
      verify: "Verify and continue",
      sending: "Sending code…",
      resend: "Resend code",
      resendIn: "Resend in {s}s",
      sendFailed: "We couldn't send the SMS. Check the number and try again.",
      invalid: "Incorrect or expired code.",
      invalidPhone: "Invalid phone number.",
      phoneTaken: "This phone is already registered. Try logging in.",
      notVerified: "Please verify your phone before continuing.",
      loginIdLabel: "Email or phone",
      forgotSmsSub: "We'll text you a 6-digit code to reset your password.",
      sendCode: "Send code",
      resetBtn: "Change password",
      resetDone: "Password updated!",
      resetDoneBody: "You can now log in with your new password.",
    },
    community: {
      eyebrow: "RED Community",
      title: "Everything your community offers, in one place",
      sub: "Join free and discover trusted businesses, professionals and events near you.",
      b1t: "Trusted directory", b1d: "Find local businesses and services recommended by your community.",
      b2t: "Talk to professionals", b2d: "Book appointments with doctors, lawyers and advisors.",
      b3t: "Community events", b3d: "Workshops, talks and activities to grow together.",
      b4t: "Direct contact", b4d: "Reach out to entrepreneurs and rate your experience.",
      formTitle: "Create your free account",
      formSub: "It takes less than a minute.",
      free: "100% free",
      submit: "Join the community",
      successTitle: "Welcome to the RED!",
      successSub: "Your account is ready. Start exploring the directory.",
      goDirectory: "Explore directory",
      premiumTitle: "RED Premium",
      premiumPrice: "$19.99/month",
      premiumDesc: "Take your membership further with unlimited access.",
      premiumB1: "Unlimited appointments with professionals",
      premiumB2: "Unlimited talks and events",
      premiumB3: "Direct WhatsApp with businesses",
      premiumCta: "I'm interested",
      premiumThanks: "Thanks! We'll contact you soon.",
      premiumActive: "Premium member",
      usageTitle: "Your activity this month",
      usageAppointments: "Professional appointments",
      usageEvents: "Talks & events",
      whatsappLocked: "Direct WhatsApp available with Premium",
      apptLimit: "You've used your 2 monthly appointments. Premium members enjoy unlimited appointments.",
      eventLimit: "You've reserved your monthly talk. Premium members enjoy unlimited events.",
      attend: "I'll attend",
      attending: "Attendance confirmed",
      loginToAttend: "Log in to attend",
      myBookings: "My appointments",
      homeEyebrow: "For the community",
      homeTitle: "Looking for trusted services near you?",
      homeSub: "Join the RED community 100% free: find local businesses, book professionals and attend events — all in one place.",
      homeCta: "Community access",
      homeFree: "100% free · no card required",
      homeCard1: "“I found my trusted lawyer in minutes”",
      homeCard1By: "María G. · Odessa, TX",
      homeCard2: "Free talk · Thursday 6PM",
      homeB1: "Trusted local directory",
      homeB2: "Appointments with professionals",
      homeB3: "Community events & talks",
      marquee: ["Solidarity", "Entrepreneurs", "Community", "Free events", "RED Online", "Trusted businesses"],
      aboutLabel: "About us",
      contactLabel: "Contact",
      viewsLabel: "views",
      contactLockedTitle: "Contact info for members",
      contactLockedSub: "Join the community for free to see phone, WhatsApp and email.",
      contactLockedCta: "Join free",
      contactLockedLogin: "I'm already a member — log in",
      dirVisitorBanner: "You're browsing as a visitor — join free to contact businesses.",
      editProfile: "Edit my profile",
      ctaWhatsapp: "Direct WhatsApp",
      ctaCall: "Call",
      ctaWebsite: "Website",
    },
    auth: {
      loginTitle: "Welcome back", loginSub: "Log in to access the directory and your account.",
      email: "Email", password: "Password", login: "Log in",
      noAccount: "Don't have an account?", registerLink: "Join the RED",
      hasAccount: "Already have an account?", loginLink: "Log in",
      successTitle: "Welcome to the RED!",
      successSub: "Your account is live. Browse the directory or share your profile.",
      goDashboard: "Go to dashboard", goDirectory: "Browse directory",
      // Choice
      chooseEyebrow: "Join the network we're building together.",
      chooseTitle: "How will you join the RED?",
      chooseSub: "Pick how you want to participate. You can always switch later.",
      asClient: "Community Member",
      asClientDesc: "Customers and neighbors looking for trusted local services.",
      asBusinessOrPro: "Entrepreneur or Professional",
      asBusinessOrProDesc: "Choose your path: business owner or licensed professional.",
      asEntrepreneur: "Entrepreneur",
      asEntrepreneurDesc: "Business owners ready to be discovered.",
      asProfessional: "Professional",
      asProfessionalDesc: "Doctors, lawyers, advisors and other licensed professionals.",
      asOrganization: "Non-Profit, Churches & Leaders",
      asOrganizationDesc: "Non-profits, churches and community leaders making a difference.",
      asEntity: "Organization or Church",
      asEntityDesc: "Nonprofits, churches and community leaders serving the community.",
      // Sub-selectors
      chooseBusinessOrProTitle: "Are you an Entrepreneur or a Professional?",
      chooseBusinessOrProSub: "Pick the one that fits you best — you can switch later.",
      chooseOrganizationTitle: "What are you registering?",
      chooseOrganizationSub: "Non-profits and churches register the organization. Leaders register themselves.",
      asNonProfit: "Non-Profit",
      asNonProfitDesc: "NGOs, foundations and chambers of commerce.",
      asChurch: "Church",
      asChurchDesc: "Churches and religious organizations.",
      asLeader: "Community Leader",
      asLeaderDesc: "Individual leaders organizing events and helping the community.",
      // Volunteer checkbox label shared
      volunteerLabel: "I'm available as a volunteer for community events",
      volunteerHint: "Organizations will be able to reach out to you for volunteer work.",
      // Entity registration
      entityTitle: "Register your community entity",
      entitySub: "Free profile for NGOs, churches, foundations and community centers.",
      entityStep1: "Account",
      entityStep2: "Representative",
      entityStep3: "Entity",
      entityStep4: "Location & Brand",
      repName: "Representative full name",
      repWhatsapp: "Representative WhatsApp",
      entityName: "Entity name",
      entityEmail: "Entity email",
      entityPhone: "Entity phone",
      entityType: "Type of community entity",
      // Volunteer
      volunteerLabel: "I also want to volunteer with the RED",
      volunteerHint: "You can change this later from your profile.",
      // Entrepreneur multi-step
      registerTitle: "Register your business or profession", registerSub: "Free profile in 3 quick steps.",
      step1: "Account", step2: "Business", step3: "Brand & Social",
      back: "Back", next: "Next", submit: "Create my profile",
      // Professional (uses the same registration form, different labels)
      professionalTitle: "Register as a Professional",
      professionalSub: "Free profile in 3 quick steps. Build trust and reach.",
      professionalStep2: "Practice & Specialty",
      professionalBusinessName: "Public name / Practice",
      professionalBusinessNameHint: "How you want to be presented (e.g. 'Dr. Carmen Lopez — Family Medicine').",
      professionalOwnerName: "Your full name",
      professionalCategory: "Main specialty",
      professionalDescription: "Tell the community what you do",
      professionalDescriptionPlaceholder: "Your experience, specialties, who you help…",
      // Client
      clientTitle: "Create your user account",
      clientSub: "Get full access to the directory and member benefits.",
      clientSubmit: "Create my account",
      interests: "What services interest you?",
      interestsHint: "Pick a few categories so we can recommend businesses to you.",
      source: "How did you hear about the RED?",
      sourceHint: "Optional, helps us improve our outreach.",
      sources: { Roxxi: "Roxxi", TRC: "TRC", UMAPT: "UMAPT", Google: "Google", Social: "Social media", Other: "Other" },
    },
    fields: {
      businessName: "Business / profession name", ownerName: "Owner / contact name", fullName: "Full name",
      category: "Category", description: "Short description",
      phone: "Mobile", city: "City", state: "State / Province", country: "Country",
      address: "Address (optional)", website: "Website",
      createPassword: "Create your password", confirmPassword: "Confirm your password",
      passwordsDoNotMatch: "Passwords do not match",
      logoUrl: "Logo", coverUrl: "Cover image",
      facebook: "Facebook", instagram: "Instagram", twitter: "X / Twitter", whatsapp: "WhatsApp",
      linkedin: "LinkedIn", tiktok: "TikTok", youtube: "YouTube",
      whatsappHint: "Include country code",
      step3OptionalNote: "All fields in this step are optional — you can complete them later from your dashboard.",
      requiredNote: "Fields marked with an asterisk are required.",
      placeholders: {
        description: "What do you offer? Who do you serve? (10-2000 chars)",
        logoUrl: "https://… (paste an image URL)",
        coverUrl: "https://… (optional)",
      },
    },
    dashboard: {
      title: "My Dashboard", welcome: "Welcome back",
      profile: "Profile", account: "Account",
      saveChanges: "Save changes", saved: "Profile updated.",
      profilePreview: "Public preview", editProfile: "Edit profile",
      clientWelcome: "Welcome to the RED",
      clientHint: "Browse the directory to discover trusted businesses.",
      goDirectory: "Go to directory",
      myRanking: "My ranking",
      myAvgRating: "My rating",
      rankFeatured: "Featured profile — top of the directory.",
      rankRegular: "Higher ratings move you up the directory.",
      reviewsEyebrow: "Received reviews",
      reviewsEmptyTitle: "No reviews yet",
      reviewsEmptyBody: "Once clients rate your profile, their reviews will appear here.",
    },
    admin: {
      title: "Admin Panel", subtitle: "Manage entrepreneurs, users and messages.",
      tabs: { stats: "Overview", users: "Registered", onboard: "Sign-up", moderators: "Moderators", plans: "Memberships", profiles: "Profiles", entrepreneurs: "Entrepreneurs", clients: "Users", entities: "Entities", events: "Events", messages: "Messages" },
      roles: { admin: "Admin", moderator: "Moderator", member: "Member", client: "Community", entrepreneur: "Entrepreneur", entity: "Entity" },
      stats: { entrepreneurs: "Entrepreneurs", clients: "Users", entities: "Entities", events: "Events", messages: "Messages", featured: "Featured", unread: "Unread", volunteers: "Volunteers" },
      charts: { signupsByDay: "Sign-ups per day", bySource: "By referral source", byRole: "Distribution by role", last30: "Last 30 days" },
      signups: {
        title: "User growth by profile type",
        subtitle: "Daily, weekly and monthly sign-ups broken down by profile",
        granDaily: "Daily · Last 30 days",
        granWeekly: "Weekly · Last 12 weeks",
        granMonthly: "Monthly · Last 12 months",
        professional: "Professionals",
        entrepreneur: "Entrepreneurs",
        community: "Community",
        entity: "Entities",
        total: "Total",
        period: "Period",
      },
      search: "Search…",
      featured: "Featured", unfeatured: "Set Featured",
      delete: "Delete", confirm: "Are you sure?", view: "View",
      exportCsv: "Export CSV",
      noResults: "No records yet.",
      contactReadAll: "Mark read",
      volunteerBadge: "Volunteer",
      // table headers
      th: { business: "Business", owner: "Owner", email: "Email", category: "Category", city: "City", featured: "★", date: "Date", actions: "Actions",
            name: "Name", phone: "Phone", interests: "Interests", source: "Source", message: "Message", read: "Read",
            entity: "Entity", entityType: "Type", representative: "Representative", volunteer: "Vol.",
            eventName: "Event", location: "Location", when: "When" },
      profiles: {
        total: "All profiles",
        kindAll: "All kinds",
        searchPh: "Search profile by name, owner, city, category…",
        empty: "No profiles match your filters.",
        thKind: "Kind", thName: "Name", thOwner: "Owner", thCity: "City", thCategory: "Category", thFeatured: "★", thActions: "Actions",
        feature: "Mark featured", unfeature: "Unmark featured",
        view: "View public",
        delete: "Delete (cascades legacy)",
      },
    },
    onboard: {
      eyebrow: "Assisted sign-up",
      title: "Register a new person",
      subtitle: "Create the account using the shared default password. The owner will receive an email with a secure link to set their personal password.",
      fFullName: "Full name", fKind: "Kind of profile", fName: "Business / organization name", fNameHint: "What appears in the directory",
      fCategory: "Category", fDescription: "Short description", fPhone: "Phone", fWhatsapp: "WhatsApp", fCity: "City", fState: "State",
      kinds: { member: "Just a member account (no profile)", business: "Business", venture: "Venture", professional: "Professional", ngo: "Non-profit", church: "Church", community_leader: "Community Leader" },
      passwordNote: "We'll create the account with the shared default password and email the owner a link to set their own. The link is valid for 24 hours.",
      submit: "Create account & send email", creating: "Creating…",
      tempPassword: "Temporary password", emailSent: "Reset email sent to",
      resentOk: "Email re-sent successfully.",
      // moderators
      modsEyebrow: "Team", modsTitle: "Moderators",
      modsSubtitle: "Moderators can register people. They cannot manage other admin data.",
      modCreate: "Add moderator", confirmDeleteMod: "Remove this moderator?", modsEmpty: "No moderators yet.",
      moderatorsAdminOnly: "Only admins can manage moderators.",
      resendEmail: "Resend password email", deleteMod: "Remove moderator",
      rasLabel: "Mark as R.A.S (Red de Amor y Solidaridad)",
      rasHint: "Check if you registered this person through the R.A.S outreach. It will be tagged in the list.",
    },
  },
  es: {
    entities: {
      types: {
        ngo: "NGO",
        foundation: "Foundation",
        church: "Church",
        community_leader: "Community Leader",
        government: "Government",
        training_center: "Training center",
        help_center: "Help center",
        health_center: "Health center",
        legal_migration_center: "Legal & migration aid center",
        chamber_commerce: "Chamber of Commerce",
        cultural_center: "Cultural center",
        food_bank: "Food bank & aid",
        informal_network: "Informal community network",
        other: "Other",
      },
    },
    events: {
      title: "Events",
      publicTitle: "Upcoming community events",
      publicSub: "Activities, workshops and volunteer opportunities from our community entities.",
      mine: "My events",
      upcoming: "Upcoming",
      empty: "No events yet.",
      create: "Create event",
      edit: "Edit event",
      name: "Event name",
      date: "Date",
      time: "Time",
      location: "Location",
      description: "Description",
      needs: "Needs (volunteers / supplies / support)",
      cover: "Cover image",
      save: "Save event",
      delete: "Delete event",
      confirmDelete: "Delete this event?",
      saved: "Event saved.",
    },
    myStats: {
      title: "My statistics",
      views: "Profile views",
      clicks: "Contact clicks",
    },
    forgot: {
      eyebrow: "Recover account",
      title: "Forgot your password?",
      subtitle: "Enter your email and we'll send you a secure link to reset it.",
      sendLink: "Send reset link",
      backToLogin: "Back to log in",
      linkLabel: "Forgot password?",
      sentTitle: "Check your inbox",
      sentBody: "If that email is registered, you'll receive a reset link in the next few minutes. Also check your spam folder.",
    },
    reset: {
      eyebrow: "New password",
      title: "Set a new password",
      subtitle: "Choose a strong password. You'll be able to log in right after.",
      newPassword: "New password",
      confirmPassword: "Confirm new password",
      submit: "Update password",
      doneTitle: "Password updated!",
      doneBody: "Redirecting you to the login page…",
      invalidTitle: "Invalid or expired link",
      invalidBody: "This reset link is no longer valid. Request a new one below.",
    },
    ratings: {
      title: "Reviews",
      avgLabel: "Average",
      reviewSingular: "review",
      reviewPlural: "reviews",
      noneTitle: "Be the first to review",
      noneSub: "Leave a rating so others can find trustworthy businesses.",
      leaveRating: "Your rating",
      yourRating: "Your rating",
      commentPlaceholder: "Share your experience (optional)…",
      submit: "Submit rating",
      removeMine: "Remove my rating",
      confirmDelete: "Remove your rating?",
      pickStars: "Pick at least 1 star.",
      ownProfileNote: "You can't rate your own profile.",
      anonymous: "Anonymous",
    },
    about: {
      heroTitle1: "A network that ",
      heroTitleAccent: "connects hearts",
      heroTitle2: ", resources and solutions.",
      heroBody: "We are RAS — Red de Amor y Solidaridad, a community that brings together people, entrepreneurs and organizations so everyone can find what they need, when they need it, in Odessa and surrounding areas.",
      missionEyebrow: "Our mission",
      missionTitle: "Connecting people, resources and opportunities to strengthen the community.",
      missionP1: "Our mission is to connect people, resources, services and opportunities to strengthen the integral wellbeing of the community, promoting unity, entrepreneurship, solidarity and service with purpose.",
      missionP2: "We work to create an accessible, human and innovative network that drives the growth of entrepreneurs, supports families, strengthens organizations and generates real social impact through community collaboration.",
      missionQuote: "Together we transform. Find here everything you need, when you need it.",
      missionQuoteBy: "— RAS Team",
      visionEyebrow: "Our vision",
      visionTitle: "The largest community support network of the Hispanic community.",
      visionP1: "To be the largest and most influential community support, connection and transformation network in the Hispanic community, expanding a model of unity and solidarity that inspires thousands of people to grow together, help each other and build a future with more opportunities, wellbeing and hope.",
      visionP2: "We envision a community where no one feels alone, where every entrepreneur has visibility, every need finds support, and every person can discover that, united, we are stronger.",
      whatWeDoEyebrow: "What do we do?",
      whatWeDoTitle: "Three ways to be part of the RED",
      forUsersTitle: "Community Members",
      forUsersBody: "Customers and neighbors who want to find services, events and trusted professionals near them. Just connect, explore and contact directly with those who can help you.",
      forEntrepreneursTitle: "Entrepreneurs",
      forEntrepreneursBody: "Business owners ready to be discovered. Showcase your business or profession to an active community. Get more visibility, more users and insights on who visits you.",
      forLeadersTitle: "Professionals",
      forLeadersBody: "Doctors, lawyers, advisors and licensed professionals. Build a public profile, earn trust through 5-star reviews, and grow your client base.",
      forEntitiesTitle: "Organizations & Churches",
      forEntitiesBody: "Nonprofits, churches, foundations and civic groups can publish events and recruit volunteers from the entire network.",
      valueSolidarityTitle: "Real solidarity",
      valueSolidarityBody: "Every registered person is part of a community fabric that supports itself. Volunteers can join local entity events with a single click.",
      valueTrustTitle: "Trust first",
      valueTrustBody: "The directory is free but gated: only registered members can see full profiles. This way we protect our entrepreneurs and guarantee real contacts.",
      statFree: "Free",
      statLanguages: "Languages",
      statEntityTypes: "Entity types",
      statPossibilities: "Possibilities",
      ctaEyebrow: "Join today",
      ctaTitle1: "We're building this ",
      ctaTitleAccent: "with you",
      ctaTitle2: ".",
      ctaBody: "Whatever your role — user, entrepreneur or entity — you have a place in the RED.",
      ctaRegister: "Register now",
      ctaDirectory: "View directory",
    },
    categories: {
      restaurants: "Restaurants", professional_services: "Professional Services",
      health_wellness: "Health & Wellness", technology: "Technology",
      construction: "Construction", beauty: "Beauty", education: "Education",
      retail: "Retail", arts_entertainment: "Arts & Entertainment",
      automotive: "Automotive", food_beverage: "Food & Beverage",
      real_estate: "Real Estate", other: "Other",
    },
    catalog: {
      title: "My catalog",
      eyebrow: "My business",
      heading: "Products & Services Catalog",
      subtitle: "Showcase up to {limit} products or services. Customers see them on your public profile and can contact you with one click.",
      empty: "You haven't added any items yet. Start with your most popular product or service.",
      tplTitle: "Start with a template",
      tplSub: "One click, edit the data, and publish.",
      addBtn: "New product or service",
      addSlotLabel: "Add new item",
      editBtn: "Edit",
      deleteBtn: "Delete",
      saveBtn: "Save",
      cancelBtn: "Cancel",
      confirmDelete: "Delete this item from your catalog?",
      limitReached: "You've reached the free limit of {limit} items. Remove one to add another.",
      slotsLeft: "{n} of {limit} slots used",
      modalNewTitle: "New product / service",
      modalEditTitle: "Edit product / service",
      fImage: "Photo",
      fImageHint: "Square image. We compress it automatically (≤300KB).",
      fGallery: "More photos (gallery)",
      fGalleryHint: "Add up to 6 extra photos of this product or service.",
      fTitle: "Title",
      fTitlePh: "e.g. Family pizza, Logo design, Tax consulting…",
      fDescription: "Short description",
      fDescriptionPh: "What makes it special? (optional)",
      fCategory: "Internal category / tag",
      fCategoryPh: "Optional. e.g. Catering, Lashes, SEO…",
      fPrice: "Price",
      fPricePh: "Leave empty to show \"Inquire\"",
      fCurrency: "Currency",
      askPrice: "Inquire",
      contactBtn: "Contact",
      // public catalog (on profile)
      publicTitle: "Catalog",
      publicSubtitle: "Browse products and services. Tap a card to contact directly.",
      publicEmpty: "This entrepreneur hasn't added items to their catalog yet.",
      // contact modal
      contactTitle: "How would you like to contact {biz}?",
      contactSubtitle: "Choose your preferred channel for \"{product}\".",
      contactWa: "WhatsApp",
      contactEmail: "Email",
      contactPhone: "Phone",
      contactClose: "Close",
      noContact: "This entrepreneur hasn't added a contact channel yet.",
      // stats
      statsTitle: "Catalog interest",
      statsSubtitle: "How many people clicked to contact each item.",
      statsEmpty: "Add products to your catalog to start receiving clicks.",
      statsColProduct: "Product / service",
      statsColClicks: "Clicks",
      statsTotal: "Total clicks",
      statsByChannel: "Clicks by channel",
      statsRecent: "Recent activity",
      statsRecentEmpty: "No clicks yet — share your profile to start receiving interest.",
      // Type toggle (Phase 5: services support)
      fType: "Type",
      productLabel: "Product",
      serviceLabel: "Service",
      fDuration: "Duration",
      fDurationPh: "e.g. 1 hr, 30 min, per session…",
    },
    myProfiles: {
      eyebrow: "My Panel · Multi-Profile",
      title: "Hi {name}, manage all your profiles from one account.",
      subtitle: "One person, one account, multiple opportunities. Add a business, a foundation, a professional practice — each one is its own card in the network.",
      totalProfiles: "Profiles",
      totalViews: "Total views",
      totalClicks: "Total clicks",
      totalRatings: "Total reviews",
      profilesHeading: "My profiles",
      addProfile: "Add new profile",
      editBtn: "Edit",
      viewBtn: "View public",
      confirmDelete: "Delete this profile?",
      emptyTitle: "You don't have any profiles yet",
      emptyBody: "Create your first profile — it can be a business, a foundation, a professional practice or anything else. You can add more later.",
      kindBusiness: "Business",
      kindVenture: "Venture",
      kindProfessional: "Professional",
      kindNgo: "Non-profit",
      kindChurch: "Church",
      kindCommunityLeader: "Community Leader",
      // Profile form
      formNewTitle: "Create new profile",
      formEditTitle: "Edit profile",
      formNewSub: "Pick the kind that fits, then complete the basics. You can polish later.",
      stepKind: "Choose kind",
      stepDetails: "Profile details",
      stepBrand: "Brand & social (optional)",
      kindHint: "You can have multiple profiles of different kinds — e.g. one business and one professional.",
      kindBusinessDesc: "Established business with customers.",
      kindVentureDesc: "Idea in development, growing.",
      kindProfessionalDesc: "Licensed professional (doctor, lawyer, advisor).",
      kindNgoDesc: "Non-profit, foundation, chamber of commerce.",
      kindChurchDesc: "Church or religious organization.",
      kindCommunityLeaderDesc: "Individual leader serving the community.",
      cancel: "Cancel",
      save: "Save",
      saving: "Saving…",
      back: "Back",
      next: "Next",
      createBtn: "Create profile",
      updateBtn: "Update profile",
      savedToast: "Profile saved.",
      backToPanel: "Back to my panel",
      changeKind: "Change",
      welcomeTitle: "Just one more step! 🎉",
      welcomeBody: "Your account is created. Complete this short form below to publish your first profile and finish your registration.",
      catalogBtn: "Catalog",
      agendaBtn: "Calendar",
      yourPlan: "Your plan", profilesLabel: "profiles", productsPerProfile: "products per profile", viewPlans: "View plans",
      profilesUsage: "You're using {used} of {max} profiles", profilesRemaining: "{n} left", profilesFull: "Limit reached — upgrade to add more",
    },
    plans: {
      eyebrow: "Memberships",
      title: "Pick the plan that fits your moment",
      subtitle: "Start free, upgrade as you grow. Each plan unlocks more profiles, more catalog items and better visibility.",
      currentPlan: "Your current plan",
      contactAdmin: "Contact an admin to upgrade",
      requestUpgrade: "Request upgrade",
      sending: "Sending…",
      requestSent: "Your request was sent. We'll contact you soon.",
    },
    adminPlans: {
      searchPh: "Search user by name or email…",
      empty: "No users for the selected plan.",
      thUser: "User", thRole: "Role", thPlan: "Plan",
    },
    profileCatalog: {
      eyebrow: "Profile catalog",
      notYours: "This profile is not yours.",
      notFound: "Profile not found.",
    },
    profileAgenda: {
      eyebrow: "My calendar",
      onlyProfessional: "Calendar is only for professional profiles.",
    },
    registerModal: {
      eyebrow: "Join the RED",
      title: "How do you want to join?",
      subtitle: "Pick the option that best describes you. You can add more profiles later.",
      footer: "Already have an account?",
      footerLink: "Sign in",
      options: {
        client: {
          title: "Community Member",
          desc: "I'm looking for services, professionals or businesses in my community.",
        },
        business: {
          title: "Business or Venture",
          desc: "I own a business and want to publish my products/services.",
        },
        professional: {
          title: "Licensed Professional",
          desc: "I'm a doctor, lawyer, coach or advisor. I want to open my online agenda.",
        },
        organization: {
          title: "Organization / Church",
          desc: "NGO, foundation, church or community leader that serves the community.",
        },
      },
    },
    registerAccount: {
      eyebrow: "New · Unified account",
      title: "Create your account once. Add as many profiles as you need.",
      subtitle: "One account for your business, your foundation, your professional practice — manage all of them from a single panel.",
      cityHint: "Where most of your activity happens (you can change this per profile).",
      submit: "Create my account",
      creating: "Creating account…",
      afterHint: "Next step: pick the kind of profile to create (business, professional, foundation, church or community leader).",
      navHint: "Unified account · Multi-profile",
      proHint: "Joining as a Professional · RED Online",
      proHintAfter: "Right after this step we'll only ask for your professional profile basics.",
      kindHint_business: "Joining as a Business",
      kindHint_venture: "Joining as a Venture",
      kindHint_professional: "Joining as a Professional · RED Online",
      kindHint_ngo: "Joining as an NGO / Foundation",
      kindHint_church: "Joining as a Church",
      kindHint_community_leader: "Joining as a Community Leader",
      pickTitle: "What kind of profile do you want?",
      pickHint: "Pick one to get started. You can add more profiles later.",
      pickRequired: "Please choose a profile type.",
      pick: {
        community: { label: "Community", desc: "Just a member — explore the RED." },
        business: { label: "Business", desc: "A local store or company." },
        venture: { label: "Venture", desc: "A small or growing venture." },
        professional: { label: "Professional", desc: "Offer appointments on RED Online." },
        ngo: { label: "NGO / Foundation", desc: "A non-profit organization." },
        church: { label: "Church", desc: "A church or ministry." },
        community_leader: { label: "Community Leader", desc: "A community representative." },
      },
    },
    registerChoice: {
      classicOr: "Or use the classic flow",
      trustNote: "We're a trusted community. Members register so businesses know who's reaching out.",
    },
    profileSwitcher: {
      eyebrow: "Active profile",
      subtitle: "Switch the profile you're managing.",
      pick: "Pick a profile",
      addProfile: "Add new profile",
      managePanel: "Manage all profiles",
    },
    userMenu: {
      signedInAs: "Signed in as",
      noProfilesYet: "No profiles yet",
      myPanel: "My panel",
    },
  },
  es: {
    redApoyo: {
      navLabel: "RED Online",
      heroEyebrow: "Red de apoyo virtual",
      heroTitle: "Citas virtuales gratuitas con profesionales de confianza",
      heroSub: "Médicos, abogados, asesores y otros profesionales donan su tiempo para ayudar a la comunidad. Explora la disponibilidad, elige un horario y agenda en segundos.",
      filterCategory: "Especialidad",
      filterCity: "Ciudad (opcional)",
      filterFrom: "Desde",
      filterTo: "Hasta",
      noResults: "No hay horarios disponibles con esos filtros. Prueba ampliar el rango de fechas o quitar filtros.",
      bookBtn: "Agendar esta cita",
      durationLabel: "Duración",
      withLabel: "Con",
      topicLabel: "Tema",
      availableLabel: "disponibles",
      professionalsCountLabel: "profesionales",
      availableSlotsLabel: "horarios libres",
      // Tira de impacto público en la landing
      impactEyebrow: "Impacto real, números reales",
      impactTitle: "Nuestra comunidad en acción",
      impactSubtitle: "Cada cita agendada es un profesional donando su tiempo. Este es el impacto hasta ahora.",
      impactHours: "horas donadas",
      impactPeople: "personas ayudadas",
      impactPros: "profesionales activos",
      impactOpen: "horarios disponibles",
      impactCta: "Agenda tu cita gratuita",
      noRatingsYet: "Sin calificaciones aún",
      viewFullProfile: "Ver perfil completo",
      // Booking modal
      bookTitle: "Agendar esta cita",
      bookSub: "Cuéntale a {pro} brevemente qué necesitas. Recibirá un correo con los detalles.",
      topicPlaceholder: "Tema corto (ej. 'Necesito ayuda con mi solicitud de visa')",
      notesLabel: "Notas (opcional)",
      notesPlaceholder: "Cualquier contexto que ayude al profesional a prepararse…",
      confirmBook: "Confirmar cita",
      booking: "Agendando…",
      bookSuccess: "¡Cita confirmada! Revisa tu correo para los detalles.",
      // Manage availability (professional dashboard)
      availabilityTitle: "Mi disponibilidad virtual",
      availabilitySub: "Abre horarios para que miembros de la comunidad agenden una sesión virtual contigo. Gratis — estás donando tu tiempo.",
      addSlotBtn: "Agregar horario",
      slotDate: "Fecha y hora de inicio",
      slotDuration: "Duración (min)",
      slotTopicHint: "Tema / especialidad (opcional)",
      slotTopicHintPlaceholder: "ej. Migración · Impuestos · Salud mental…",
      saveSlot: "Guardar",
      cancelSlot: "Cancelar",
      noSlots: "Aún no has abierto horarios.",
      emptyHowItWorks: "Así funciona",
      emptyTitle: "Abre tus primeros horarios en 3 pasos",
      emptySub: "Los pacientes de la comunidad podrán agendar directamente en los horarios que tú publiques.",
      emptyStep1Title: "1. Publica un horario",
      emptyStep1Desc: "Elige fecha, hora y duración (15 a 120 min).",
      emptyStep2Title: "2. Recibe la reserva",
      emptyStep2Desc: "Un paciente reserva y verás su nombre y motivo aquí.",
      emptyStep3Title: "3. Atiende la cita",
      emptyStep3Desc: "Contacta al paciente en el horario acordado (Zoom, teléfono, etc).",
      emptyAddFirst: "Agregar mi primer horario",
      emptyPreviewHint: "Los pacientes verán tu agenda en la página RED Online.",
      presetIn2h: "Hoy +2h",
      presetTomorrow: "Mañana 9:00",
      presetNext3d: "En 3 días 15:00",
      statusOpen: "Disponible",
      statusBooked: "Reservado",
      removeBtn: "Eliminar",
      // Mis reservas
      myBookingsTitle: "Mis citas agendadas",
      myBookingsEmpty: "Aún no has agendado citas.",
      cancelBooking: "Cancelar",
      // Admin
      adminTotalHours: "Horas donadas",
      adminUsersHelped: "Personas ayudadas",
      adminBookings: "Citas agendadas",
      adminTopPros: "Profesionales destacados",
      // Banner de unirse al RED Online (sobre el listado)
      joinEyebrow: "¿Eres profesional?",
      joinTitleGuest: "Únete a la RED Online y dona tu tiempo",
      joinSubGuest: "Médicos, abogados, coaches y asesores: crea tu cuenta gratis y abre horarios virtuales en minutos.",
      joinCtaGuest: "Crear mi cuenta",
      joinTitleMember: "Activa tu perfil profesional",
      joinSubMember: "Crea un perfil profesional para abrir tu agenda y recibir reservas.",
      joinCtaMember: "Crear perfil profesional",
      joinTitlePro: "Gestiona tu agenda de RED Online",
      joinSubPro: "Abre nuevos horarios y revisa tus citas en un solo lugar.",
      joinCtaPro: "Ir a mi agenda",
      joinSecondary: "Cómo funciona",
    },
    nav: {
      home: "Inicio", directory: "Directorio", events: "Eventos", about: "Conócenos", contact: "Contacto",
      login: "Iniciar sesión", register: "Únete a la RED",
      dashboard: "Mi perfil", admin: "Admin", logout: "Cerrar sesión",
    },
    topbar: {
      tagline: "Sé parte de un movimiento que conecta corazones, recursos y soluciones.",
      join: "Únete a la RED",
    },
    hero: {
      eyebrow: "Encuentra aquí todo lo que necesitas, cuando lo necesitas",
      title: "RAS: La primera red que conecta servicios reales con personas reales.",
      taglineParts: ["Movemos Corazones.", "Unimos Esfuerzos.", "Impacto Real."],
      subtitle: "Una Red que conectará todo y que estamos construyendo contigo.",
      ctaPrimary: "Únete a la RED — es gratis",
      ctaSecondary: "Explorar el directorio",
      trustLine: "+600 profesionales activos en la RED",
      membersLabel: "miembros inscritos en la RED",
      membersLabelLoading: "Una comunidad que crece",
      businessesLabel: "negocios y emprendimientos",
      stats: [
        { v: "500+", l: "Miembros en la red" },
        { v: "12", l: "Industrias" },
        { v: "100%", l: "Atención bilingüe" },
      ],
    },
    services: {
      title: "Cuatro formas de conectar, una sola RED.",
      subtitle: "No competimos — conectamos y coordinamos soluciones.",
      items: [
        { t: "Miembros de la Comunidad", d: "Buscan servicios locales de confianza." },
        { t: "Emprendedores", d: "Crean oportunidades y consiguen más usuarios." },
        { t: "Profesionales", d: "Médicos, abogados, asesores construyendo confianza." },
        { t: "Organizaciones e Iglesias", d: "Sirven a la comunidad." },
      ],
    },
    why: {
      eyebrow: "¿Por qué unirte a la RED?",
      title: "Encuentra más usuarios. Crece con la comunidad.",
      subtitle: "Seas usuario o emprendedor, registrarte te conecta a servicios locales de confianza y nuevas oportunidades.",
      bullets: [
        { t: "Perfil público gratuito", d: "Muestra tu negocio con foto, historia, contacto y redes sociales." },
        { t: "Descubrimiento local", d: "Los usuarios que buscan tu categoría y ciudad te encuentran primero." },
        { t: "Confianza comunitaria", d: "El sello RED indica un negocio verificado y con valores." },
        { t: "Alcance bilingüe", d: "Llega a usuarios en inglés y español en un solo lugar." },
      ],
      cta: "Crear mi cuenta gratis",
    },
    directoryPreview: {
      eyebrow: "Negocios destacados",
      title: "Descubre emprendedores de la RED.",
      seeAll: "Ver directorio completo",
    },
    directory: {
      title: "Emprendedores y Negocios",
      subtitle: "Explora el directorio y conecta con emprendedores y negocios locales.",
      searchPlaceholder: "Busca por nombre, ciudad, palabra clave…",
      all: "Todos", results: "resultados",
      empty: "No se encontraron negocios. Prueba con otra búsqueda.",
      view: "Ver perfil",
      tabEntrepreneurs: "Emprendedores y Negocios",
      tabProfessionals: "Profesionales",
      emptyProfessionals: "No se encontraron profesionales. Prueba con otra búsqueda.",
      entrepreneursAndBusiness: "Emprendedores y Negocios",
      lookingForPros: "¿Buscas un profesional? Visita RED Online",
    },
    paywall: {
      eyebrow: "Solo miembros",
      title: "Directorio de Servicios",
      subtitle: "Explora el directorio y conéctate ahora.",
      invite: "Para encontrar lo que necesitas, cuando lo necesitas,",
      inviteCta: "solo regístrate.",
      whyTitle: "¿Por qué te lo pedimos?",
      whyText: "Somos una comunidad de confianza. Los miembros se registran para que los negocios sepan quién los contacta.",
      asClient: "Registrarme como usuario",
      asClientDesc: "Quiero encontrar servicios y eventos de confianza en Odessa y sus alrededores.",
      asEntrepreneur: "Registrarme con mi emprendimiento o profesión",
      asEntrepreneurDesc: "Obtén mayor visibilidad, gana más tiempo y más usuarios que utilicen tu servicio.",
      registerCta: "Registrarme gratis",
      already: "¿Ya eres miembro?",
      loginLink: "Inicia sesión",
    },
    about: {
      eyebrow: "Sobre Nosotros", title: "Quiénes somos",
      body: "La Red de Amor y Solidaridad une medios, organizaciones sin fines de lucro, iglesias, emprendedores y líderes para generar impacto real y sostenible. No competimos — conectamos y coordinamos soluciones.",
      mission: { t: "Misión", d: "Conectar a actores clave de la comunidad para vincular necesidades con recursos, fortalecer iniciativas sociales y generar impacto sostenible a través de la unidad, transparencia y compromiso colectivo." },
      vision: { t: "Visión", d: "Ser modelo de colaboración comunitaria que inspire unidad efectiva y transformación social sostenible — prueba de que cuando una comunidad camina junta, el cambio es inevitable." },
    },
    contact: {
      eyebrow: "Contacto", title: "¿Cómo podemos ayudarte?",
      subtitle: "¿Tienes una pregunta? Completa el formulario y te responderemos.",
      name: "Nombre completo", email: "Correo electrónico", role: "Tipo de participación",
      contribution: "¿Cómo deseas aportar a la RED?", message: "Mensaje",
      send: "Enviar mensaje", sent: "Mensaje enviado. ¡Te contactaremos pronto!",
      roles: ["Organización sin ánimo de lucro", "Medio de comunicación", "Empresario", "Iglesia", "Voluntario", "Líder comunitario"],
      contributions: ["Voluntariado", "Alianza estratégica", "Donaciones o recursos", "Apoyo comunitario"],
      address: "Dirección", hours: "Horario", contacts: "Contactos",
    },
    footer: {
      tag: "No competimos — conectamos y coordinamos soluciones.",
      links: "Enlaces útiles", services: "Servicios", contactNow: "Contacto",
      rights: "Diseñado por el equipo UMATP",
    },
    otp: {
      createWith: "Crear tu cuenta con",
      emailOpt: "Correo",
      phoneOpt: "Teléfono",
      title: "Verifica tu teléfono",
      sub: "Te enviamos un código de 6 dígitos por SMS al",
      codeLabel: "Código de verificación",
      verify: "Verificar y continuar",
      sending: "Enviando código…",
      resend: "Reenviar código",
      resendIn: "Reenviar en {s}s",
      sendFailed: "No pudimos enviar el SMS. Revisa el número e intenta de nuevo.",
      invalid: "Código incorrecto o expirado.",
      invalidPhone: "Número de teléfono inválido.",
      phoneTaken: "Este teléfono ya está registrado. Intenta iniciar sesión.",
      notVerified: "Verifica tu teléfono antes de continuar.",
      loginIdLabel: "Correo o teléfono",
      forgotSmsSub: "Te enviaremos un código de 6 dígitos por SMS para restablecer tu contraseña.",
      sendCode: "Enviar código",
      resetBtn: "Cambiar contraseña",
      resetDone: "¡Contraseña actualizada!",
      resetDoneBody: "Ya puedes iniciar sesión con tu nueva contraseña.",
    },
    community: {
      eyebrow: "Comunidad RED",
      title: "Todo lo que tu comunidad ofrece, en un solo lugar",
      sub: "Únete gratis y descubre negocios, profesionales y eventos de confianza cerca de ti.",
      b1t: "Directorio confiable", b1d: "Encuentra negocios y servicios locales recomendados por tu comunidad.",
      b2t: "Habla con profesionales", b2d: "Agenda citas con doctores, abogados y asesores.",
      b3t: "Eventos comunitarios", b3d: "Talleres, charlas y actividades para crecer juntos.",
      b4t: "Contacto directo", b4d: "Comunícate con emprendedores y califica tu experiencia.",
      formTitle: "Crea tu cuenta gratis",
      formSub: "Toma menos de un minuto.",
      free: "100% gratis",
      submit: "Unirme a la comunidad",
      successTitle: "¡Bienvenido a la RED!",
      successSub: "Tu cuenta está lista. Empieza a explorar el directorio.",
      goDirectory: "Explorar directorio",
      premiumTitle: "RED Premium",
      premiumPrice: "$19.99/mes",
      premiumDesc: "Lleva tu membresía más lejos con acceso ilimitado.",
      premiumB1: "Citas ilimitadas con profesionales",
      premiumB2: "Charlas y eventos ilimitados",
      premiumB3: "WhatsApp directo con los negocios",
      premiumCta: "Me interesa",
      premiumThanks: "¡Gracias! Te contactaremos pronto.",
      premiumActive: "Miembro Premium",
      usageTitle: "Tu actividad este mes",
      usageAppointments: "Citas con profesionales",
      usageEvents: "Charlas y eventos",
      whatsappLocked: "WhatsApp directo disponible con Premium",
      apptLimit: "Ya usaste tus 2 citas de este mes. Los miembros Premium disfrutan citas ilimitadas.",
      eventLimit: "Ya reservaste tu charla de este mes. Los miembros Premium disfrutan eventos ilimitados.",
      attend: "Asistiré",
      attending: "Asistencia confirmada",
      loginToAttend: "Inicia sesión para asistir",
      myBookings: "Mis citas",
      homeEyebrow: "Para la comunidad",
      homeTitle: "¿Buscas servicios de confianza cerca de ti?",
      homeSub: "Únete a la comunidad RED 100% gratis: encuentra negocios locales, agenda con profesionales y asiste a eventos — todo en un solo lugar.",
      homeCta: "Acceso Comunidad",
      homeFree: "100% gratis · sin tarjeta",
      homeCard1: "“Encontré mi abogado de confianza en minutos”",
      homeCard1By: "María G. · Odessa, TX",
      homeCard2: "Charla gratuita · Jueves 6PM",
      homeB1: "Directorio local confiable",
      homeB2: "Citas con profesionales",
      homeB3: "Eventos y charlas comunitarias",
      marquee: ["Solidaridad", "Emprendedores", "Comunidad", "Eventos gratuitos", "RED Online", "Negocios confiables"],
      aboutLabel: "Sobre nosotros",
      contactLabel: "Contacto",
      viewsLabel: "visitas",
      contactLockedTitle: "Datos de contacto para miembros",
      contactLockedSub: "Únete gratis a la comunidad para ver teléfono, WhatsApp y correo.",
      contactLockedCta: "Unirme gratis",
      contactLockedLogin: "Ya soy miembro — iniciar sesión",
      dirVisitorBanner: "Estás explorando como visitante — únete gratis para contactar a los negocios.",
      editProfile: "Editar mi perfil",
      ctaWhatsapp: "WhatsApp directo",
      ctaCall: "Llamar",
      ctaWebsite: "Sitio web",
    },
    auth: {
      loginTitle: "Bienvenido de nuevo", loginSub: "Inicia sesión para acceder al directorio y tu cuenta.",
      email: "Correo electrónico", password: "Contraseña", login: "Iniciar sesión",
      noAccount: "¿No tienes cuenta?", registerLink: "Únete a la RED",
      hasAccount: "¿Ya tienes cuenta?", loginLink: "Inicia sesión",
      successTitle: "¡Bienvenido a la RED!",
      successSub: "Tu cuenta está activa. Explora el directorio o comparte tu perfil.",
      goDashboard: "Ir al panel", goDirectory: "Ver directorio",
      chooseEyebrow: "Únete a la Red que estamos construyendo juntos.",
      chooseTitle: "¿Cómo te unes a la RED?",
      chooseSub: "Elige cómo quieres participar. Puedes cambiar después.",
      asClient: "Miembro de la Comunidad",
      asClientDesc: "Clientes y vecinos buscando servicios locales de confianza.",
      asBusinessOrPro: "Emprendedor o Profesional",
      asBusinessOrProDesc: "Elige tu camino: dueño de negocio o profesional con licencia.",
      asEntrepreneur: "Emprendedor(a)",
      asEntrepreneurDesc: "Dueños de negocio listos para ser descubiertos.",
      asProfessional: "Profesional",
      asProfessionalDesc: "Médicos, abogados, asesores y otros profesionales con licencia.",
      asOrganization: "Non-Profit, Iglesias y Líderes",
      asOrganizationDesc: "Organizaciones sin fines de lucro, iglesias y líderes comunitarios que generan impacto.",
      asEntity: "Organización o Iglesia",
      asEntityDesc: "ONGs, iglesias y líderes comunitarios que sirven a la comunidad.",
      // Sub-selectores
      chooseBusinessOrProTitle: "¿Eres Emprendedor o Profesional?",
      chooseBusinessOrProSub: "Elige el que mejor te describe — puedes cambiar después.",
      chooseOrganizationTitle: "¿Qué vas a registrar?",
      chooseOrganizationSub: "Las non-profits e iglesias registran la organización. Los líderes se registran a sí mismos.",
      asNonProfit: "Non-Profit",
      asNonProfitDesc: "ONGs, fundaciones y cámaras de comercio.",
      asChurch: "Iglesia",
      asChurchDesc: "Iglesias y organizaciones religiosas.",
      asLeader: "Líder Comunitario(a)",
      asLeaderDesc: "Líderes que organizan eventos y ayudan a la comunidad.",
      // Checkbox de voluntario compartido
      volunteerLabel: "Estoy disponible como voluntario para eventos comunitarios",
      volunteerHint: "Las organizaciones podrán contactarte para trabajo voluntario.",
      // Entidad
      entityTitle: "Registra tu entidad comunitaria",
      entitySub: "Perfil gratuito para ONGs, iglesias, fundaciones y centros comunitarios.",
      entityStep1: "Cuenta",
      entityStep2: "Representante",
      entityStep3: "Entidad",
      entityStep4: "Ubicación y Marca",
      repName: "Nombre completo del representante",
      repWhatsapp: "WhatsApp del representante",
      entityName: "Nombre de la entidad",
      entityEmail: "Correo electrónico de la entidad",
      entityPhone: "Celular de la entidad",
      entityType: "Tipo de entidad comunitaria",
      // Voluntario
      volunteerLabel: "También quiero ser voluntario con la RED",
      volunteerHint: "Puedes cambiarlo después desde tu perfil.",
      registerTitle: "Registra tu emprendimiento o profesión", registerSub: "Perfil gratuito en 3 pasos rápidos.",
      step1: "Cuenta", step2: "Negocio", step3: "Marca y Redes",
      back: "Atrás", next: "Siguiente", submit: "Crear mi perfil",
      // Profesional (usa el mismo formulario, distintas etiquetas)
      professionalTitle: "Regístrate como Profesional",
      professionalSub: "Perfil gratuito en 3 pasos rápidos. Construye confianza y alcance.",
      professionalStep2: "Práctica y Especialidad",
      professionalBusinessName: "Nombre público / Práctica",
      professionalBusinessNameHint: "Cómo quieres ser presentado(a) (ej. 'Dra. Carmen López — Medicina familiar').",
      professionalOwnerName: "Tu nombre completo",
      professionalCategory: "Especialidad principal",
      professionalDescription: "Cuéntale a la comunidad qué haces",
      professionalDescriptionPlaceholder: "Tu experiencia, especialidades, a quién ayudas…",
      clientTitle: "Crea tu cuenta de usuario",
      clientSub: "Acceso completo al directorio y beneficios de miembro.",
      clientSubmit: "Crear mi cuenta",
      interests: "¿Qué servicios te interesan?",
      interestsHint: "Elige algunas categorías para recomendarte negocios.",
      source: "¿Por dónde nos conociste?",
      sourceHint: "Opcional, nos ayuda a mejorar.",
      sources: { Roxxi: "Roxxi", TRC: "TRC", UMAPT: "UMAPT", Google: "Google", Social: "Redes sociales", Other: "Otro" },
    },
    fields: {
      businessName: "Nombre de tu emprendimiento", ownerName: "Nombre del dueño / contacto", fullName: "Nombre completo",
      category: "Categoría", description: "Descripción breve",
      phone: "Celular", city: "Ciudad", state: "Estado / Provincia", country: "País",
      address: "Dirección (opcional)", website: "Sitio web",
      createPassword: "Crea tu contraseña", confirmPassword: "Confirmar contraseña",
      passwordsDoNotMatch: "Las contraseñas no coinciden",
      logoUrl: "Logo", coverUrl: "Imagen de portada",
      facebook: "Facebook", instagram: "Instagram", twitter: "X / Twitter", whatsapp: "WhatsApp",
      linkedin: "LinkedIn", tiktok: "TikTok", youtube: "YouTube",
      whatsappHint: "Incluir indicativo del país",
      step3OptionalNote: "Todos los campos de este paso son opcionales — puedes completarlos después desde tu panel.",
      requiredNote: "Los campos marcados con asterisco son obligatorios.",
      placeholders: {
        description: "¿Qué ofreces? ¿A quién atiendes? (10-2000 caracteres)",
        logoUrl: "https://… (pega una URL de imagen)",
        coverUrl: "https://… (opcional)",
      },
    },
    dashboard: {
      title: "Mi Panel", welcome: "Bienvenido",
      profile: "Perfil", account: "Cuenta",
      saveChanges: "Guardar cambios", saved: "Perfil actualizado.",
      profilePreview: "Vista pública", editProfile: "Editar perfil",
      clientWelcome: "Bienvenido a la RED",
      clientHint: "Explora el directorio y descubre negocios de confianza.",
      goDirectory: "Ir al directorio",
      myRanking: "Mi ranking",
      myAvgRating: "Mi calificación",
      rankFeatured: "Perfil destacado — aparece arriba en el directorio.",
      rankRegular: "Mejores calificaciones te suben en el directorio.",
      reviewsEyebrow: "Reseñas recibidas",
      reviewsEmptyTitle: "Aún no tienes reseñas",
      reviewsEmptyBody: "Cuando los usuarios califiquen tu perfil, sus comentarios aparecerán aquí.",
    },
    admin: {
      title: "Panel de Admin", subtitle: "Gestiona emprendedores, usuarios y mensajes.",
      tabs: { stats: "Resumen", users: "Inscritos", onboard: "Inscribir", moderators: "Moderadores", plans: "Membresías", profiles: "Perfiles", entrepreneurs: "Emprendedores", clients: "Usuarios", entities: "Entidades", events: "Eventos", messages: "Mensajes" },
      roles: { admin: "Admin", moderator: "Moderador", member: "Miembro", client: "Comunidad", entrepreneur: "Emprendedor", entity: "Entidad" },
      stats: { entrepreneurs: "Emprendedores", clients: "Usuarios", entities: "Entidades", events: "Eventos", messages: "Mensajes", featured: "Destacados", unread: "No leídos", volunteers: "Voluntarios" },
      charts: { signupsByDay: "Registros por día", bySource: "Por fuente de referido", byRole: "Distribución por rol", last30: "Últimos 30 días" },
      signups: {
        title: "Crecimiento de usuarios por tipo de perfil",
        subtitle: "Inscritos diarios, semanales y mensuales categorizados por perfil",
        granDaily: "Diario · Últimos 30 días",
        granWeekly: "Semanal · Últimas 12 semanas",
        granMonthly: "Mensual · Últimos 12 meses",
        professional: "Profesionales",
        entrepreneur: "Emprendimientos",
        community: "Comunidad",
        entity: "Entidades",
        total: "Total",
        period: "Periodo",
      },
      search: "Buscar…",
      featured: "Destacado", unfeatured: "Hacer Destacado",
      delete: "Eliminar", confirm: "¿Estás seguro?", view: "Ver",
      exportCsv: "Exportar CSV",
      noResults: "Sin registros aún.",
      contactReadAll: "Marcar leído",
      volunteerBadge: "Voluntario",
      th: { business: "Negocio", owner: "Dueño", email: "Email", category: "Categoría", city: "Ciudad", featured: "★", date: "Fecha", actions: "Acciones",
            name: "Nombre", phone: "Teléfono", interests: "Intereses", source: "Origen", message: "Mensaje", read: "Leído",
            entity: "Entidad", entityType: "Tipo", representative: "Representante", volunteer: "Vol.",
            eventName: "Evento", location: "Lugar", when: "Cuándo" },
      profiles: {
        total: "Todos los perfiles",
        kindAll: "Todos los tipos",
        searchPh: "Buscar perfil por nombre, dueño, ciudad, categoría…",
        empty: "No hay perfiles que coincidan con tus filtros.",
        thKind: "Tipo", thName: "Nombre", thOwner: "Dueño", thCity: "Ciudad", thCategory: "Categoría", thFeatured: "★", thActions: "Acciones",
        feature: "Marcar como destacado", unfeature: "Quitar destacado",
        view: "Ver público",
        delete: "Eliminar (cascada legacy)",
      },
    },
    onboard: {
      eyebrow: "Inscripción asistida",
      title: "Registrar una nueva persona",
      subtitle: "Crea la cuenta con la contraseña genérica compartida. Le llegará al dueño un correo con un enlace seguro para que cree su contraseña personal.",
      fFullName: "Nombre completo", fKind: "Tipo de perfil", fName: "Nombre del negocio / organización", fNameHint: "Lo que aparece en el directorio",
      fCategory: "Categoría", fDescription: "Descripción corta", fPhone: "Teléfono", fWhatsapp: "WhatsApp", fCity: "Ciudad", fState: "Estado",
      kinds: { member: "Solo cuenta (sin perfil)", business: "Negocio", venture: "Emprendimiento", professional: "Profesional", ngo: "Fundación / ONG", church: "Iglesia", community_leader: "Líder Comunitario" },
      passwordNote: "Crearemos la cuenta con la contraseña genérica compartida y enviaremos al dueño un correo con un enlace para que cree la suya. El enlace expira en 24 horas.",
      submit: "Crear cuenta y enviar correo", creating: "Creando…",
      tempPassword: "Contraseña temporal", emailSent: "Correo enviado a",
      resentOk: "Correo reenviado correctamente.",
      // moderators
      modsEyebrow: "Equipo", modsTitle: "Moderadores",
      modsSubtitle: "Los moderadores pueden inscribir personas. No pueden gestionar otros datos del admin.",
      modCreate: "Agregar moderador", confirmDeleteMod: "¿Quitar este moderador?", modsEmpty: "Aún no hay moderadores.",
      moderatorsAdminOnly: "Solo los administradores pueden gestionar moderadores.",
      resendEmail: "Reenviar correo de contraseña", deleteMod: "Quitar moderador",
      rasLabel: "Marcar como R.A.S (Red de Amor y Solidaridad)",
      rasHint: "Marca si inscribiste a esta persona a través de R.A.S. Quedará identificada en la lista.",
    },
    entities: {
      types: {
        ngo: "ONG",
        foundation: "Fundación",
        church: "Iglesia",
        community_leader: "Líder Comunitario(a)",
        government: "Gubernamental",
        training_center: "Centro de formación",
        help_center: "Centro de ayuda",
        health_center: "Centro de salud",
        legal_migration_center: "Centro de ayuda legal y migratoria",
        chamber_commerce: "Cámara de Comercio",
        cultural_center: "Centro Cultural",
        food_bank: "Banco de alimentos y ayuda",
        informal_network: "Red comunitaria informal",
        other: "Otro",
      },
    },
    events: {
      title: "Eventos",
      publicTitle: "Próximos eventos comunitarios",
      publicSub: "Actividades, talleres y oportunidades de voluntariado de nuestras entidades comunitarias.",
      mine: "Mis eventos",
      upcoming: "Próximos",
      empty: "Aún no hay eventos.",
      create: "Crear evento",
      edit: "Editar evento",
      name: "Nombre del evento",
      date: "Fecha",
      time: "Hora",
      location: "Lugar",
      description: "Descripción",
      needs: "Necesidades (voluntarios / insumos / apoyo)",
      cover: "Imagen de portada",
      save: "Guardar evento",
      delete: "Eliminar evento",
      confirmDelete: "¿Eliminar este evento?",
      saved: "Evento guardado.",
    },
    myStats: {
      title: "Mis estadísticas",
      views: "Vistas al perfil",
      clicks: "Clics de contacto",
    },
    forgot: {
      eyebrow: "Recuperar cuenta",
      title: "¿Olvidaste tu contraseña?",
      subtitle: "Ingresa tu correo y te enviaremos un enlace seguro para restablecerla.",
      sendLink: "Enviar enlace",
      backToLogin: "Volver a iniciar sesión",
      linkLabel: "¿Olvidaste tu contraseña?",
      sentTitle: "Revisa tu bandeja de entrada",
      sentBody: "Si ese correo está registrado, recibirás un enlace para restablecer tu contraseña en los próximos minutos. Revisa también la carpeta de spam.",
    },
    reset: {
      eyebrow: "Nueva contraseña",
      title: "Crea una nueva contraseña",
      subtitle: "Elige una contraseña segura. Podrás iniciar sesión inmediatamente después.",
      newPassword: "Nueva contraseña",
      confirmPassword: "Confirmar nueva contraseña",
      submit: "Actualizar contraseña",
      doneTitle: "¡Contraseña actualizada!",
      doneBody: "Te estamos redirigiendo a la página de inicio de sesión…",
      invalidTitle: "Enlace inválido o expirado",
      invalidBody: "Este enlace de restablecimiento ya no es válido. Solicita uno nuevo abajo.",
    },
    ratings: {
      title: "Reseñas",
      avgLabel: "Promedio",
      reviewSingular: "reseña",
      reviewPlural: "reseñas",
      noneTitle: "Sé el primero en dejar una reseña",
      noneSub: "Califica para que la comunidad encuentre emprendimientos de confianza.",
      leaveRating: "Tu calificación",
      yourRating: "Tu calificación",
      commentPlaceholder: "Cuéntanos tu experiencia (opcional)…",
      submit: "Enviar calificación",
      removeMine: "Eliminar mi calificación",
      confirmDelete: "¿Eliminar tu calificación?",
      pickStars: "Elige al menos 1 estrella.",
      ownProfileNote: "No puedes calificar tu propio perfil.",
      anonymous: "Anónimo",
    },
    about: {
      heroTitle1: "Una red que ",
      heroTitleAccent: "conecta corazones",
      heroTitle2: ", recursos y soluciones.",
      heroBody: "Somos RAS — Red de Amor y Solidaridad, una comunidad que une a personas, emprendedores y organizaciones para que todos encuentren lo que necesitan, cuando lo necesitan, en Odessa y sus alrededores.",
      missionEyebrow: "Nuestra misión",
      missionTitle: "Conectamos personas, recursos y oportunidades para fortalecer la comunidad.",
      missionP1: "Nuestra misión es conectar personas, recursos, servicios y oportunidades para fortalecer el bienestar integral de la comunidad, promoviendo la unidad, el emprendimiento, la solidaridad y el servicio con propósito.",
      missionP2: "Trabajamos para crear una red accesible, humana e innovadora que impulse el crecimiento de emprendedores, apoye a las familias, fortalezca a las organizaciones y genere impacto social real a través de la colaboración comunitaria.",
      missionQuote: "Juntos transformamos. Encuentra aquí todo lo que necesitas, cuando lo necesitas.",
      missionQuoteBy: "— Equipo RAS",
      visionEyebrow: "Nuestra visión",
      visionTitle: "La red comunitaria más grande e influyente de la comunidad hispana.",
      visionP1: "Ser la red comunitaria de apoyo, conexión y transformación más grande e influyente de la comunidad hispana, expandiendo un modelo de unidad y solidaridad que inspire a miles de personas a crecer juntas, ayudarse mutuamente y construir un futuro con más oportunidades, bienestar y esperanza.",
      visionP2: "Visualizamos una comunidad donde nadie se sienta solo, donde cada emprendimiento tenga visibilidad, cada necesidad encuentre apoyo y cada persona pueda descubrir que, unidos, somos más fuertes.",
      whatWeDoEyebrow: "¿Qué hacemos?",
      whatWeDoTitle: "Tres formas de formar parte de la RED",
      forUsersTitle: "Miembros de la Comunidad",
      forUsersBody: "Clientes y vecinos que quieren encontrar servicios, eventos y profesionales de confianza. Solo conéctate, explora y contacta directamente con quienes pueden ayudarte.",
      forEntrepreneursTitle: "Emprendedores",
      forEntrepreneursBody: "Dueños de negocio listos para ser descubiertos. Muestra tu emprendimiento o profesión a toda una comunidad activa. Obtén mayor visibilidad, más usuarios y estadísticas de quién te visita.",
      forLeadersTitle: "Profesionales",
      forLeadersBody: "Médicos, abogados, asesores y profesionales con licencia. Construye un perfil público, gana confianza con calificaciones de 5 estrellas y haz crecer tu base de clientes.",
      forEntitiesTitle: "Organizaciones e Iglesias",
      forEntitiesBody: "ONGs, iglesias, fundaciones y grupos cívicos pueden publicar eventos y convocar voluntarios de toda la red.",
      valueSolidarityTitle: "Solidaridad real",
      valueSolidarityBody: "Cada persona registrada forma parte de un tejido comunitario que se apoya. Los voluntarios pueden sumarse a eventos de entidades locales con un solo clic.",
      valueTrustTitle: "Confianza primero",
      valueTrustBody: "El directorio es gratuito pero protegido: solo miembros registrados pueden ver los perfiles completos. Así protegemos a nuestros emprendedores y garantizamos contactos reales.",
      statFree: "Gratuito",
      statLanguages: "Idiomas",
      statEntityTypes: "Tipos de entidad",
      statPossibilities: "Posibilidades",
      ctaEyebrow: "Únete hoy",
      ctaTitle1: "Esto lo estamos construyendo ",
      ctaTitleAccent: "contigo",
      ctaTitle2: ".",
      ctaBody: "Sea cual sea tu rol —usuario, emprendedor o entidad— tienes un lugar en la RED.",
      ctaRegister: "Registrarme ahora",
      ctaDirectory: "Ver el directorio",
    },
    categories: {
      restaurants: "Restaurantes", professional_services: "Servicios profesionales",
      health_wellness: "Salud y bienestar", technology: "Tecnología",
      construction: "Construcción", beauty: "Belleza", education: "Educación",
      retail: "Comercio", arts_entertainment: "Arte y entretenimiento",
      automotive: "Automotriz", food_beverage: "Comida y bebida",
      real_estate: "Bienes raíces", other: "Otro",
    },
    catalog: {
      title: "Mi catálogo",
      subtitle: "Muestra hasta {limit} productos o servicios. Tus clientes los verán en tu perfil público y podrán contactarte con un clic.",
      empty: "Aún no has agregado productos o servicios. Empieza con tu más popular.",
      tplTitle: "Empieza con una plantilla",
      tplSub: "Un click, edita los datos, y publica.",
      eyebrow: "Mi negocio",
      heading: "Catálogo de Productos y Servicios",
      addBtn: "Nuevo producto o servicio",
      addSlotLabel: "Agregar nuevo ítem",
      editBtn: "Editar",
      deleteBtn: "Eliminar",
      saveBtn: "Guardar",
      cancelBtn: "Cancelar",
      confirmDelete: "¿Eliminar este elemento de tu catálogo?",
      limitReached: "Alcanzaste el límite gratuito de {limit} elementos. Elimina uno para agregar otro.",
      slotsLeft: "{n} de {limit} espacios usados",
      modalNewTitle: "Nuevo producto / servicio",
      modalEditTitle: "Editar producto / servicio",
      fImage: "Foto",
      fImageHint: "Imagen cuadrada. La comprimimos automáticamente (≤300KB).",
      fGallery: "Más fotos (galería)",
      fGalleryHint: "Agrega hasta 6 fotos adicionales de este producto o servicio.",
      fTitle: "Título",
      fTitlePh: "Ej. Pizza familiar, Diseño de logo, Asesoría tributaria…",
      fDescription: "Descripción corta",
      fDescriptionPh: "¿Qué lo hace especial? (opcional)",
      fCategory: "Categoría interna / etiqueta",
      fCategoryPh: "Opcional. Ej. Catering, Lashes, SEO…",
      fPrice: "Precio",
      fPricePh: "Déjalo vacío para mostrar \"Consultar\"",
      fCurrency: "Moneda",
      askPrice: "Consultar",
      contactBtn: "Contactar",
      // public catalog (on profile)
      publicTitle: "Catálogo",
      publicSubtitle: "Descubre productos y servicios. Toca una tarjeta para contactar directamente.",
      publicEmpty: "Este emprendedor aún no ha agregado elementos a su catálogo.",
      // contact modal
      contactTitle: "¿Cómo quieres contactar a {biz}?",
      contactSubtitle: "Elige tu canal preferido para \"{product}\".",
      contactWa: "WhatsApp",
      contactEmail: "Correo",
      contactPhone: "Teléfono",
      contactClose: "Cerrar",
      noContact: "Este emprendedor aún no ha agregado un canal de contacto.",
      // stats
      statsTitle: "Interés en tu catálogo",
      statsSubtitle: "Cuántas personas hicieron clic para contactar cada elemento.",
      statsEmpty: "Agrega productos a tu catálogo para empezar a recibir clics.",
      statsColProduct: "Producto / servicio",
      statsColClicks: "Clics",
      statsTotal: "Clics totales",
      statsByChannel: "Clics por canal",
      statsRecent: "Actividad reciente",
      statsRecentEmpty: "Aún sin clics — comparte tu perfil para empezar a recibir interés.",
      // Type toggle (Fase 5: soporte de servicios)
      fType: "Tipo",
      productLabel: "Producto",
      serviceLabel: "Servicio",
      fDuration: "Duración",
      fDurationPh: "ej. 1 hr, 30 min, por sesión…",
    },
    myProfiles: {
      eyebrow: "Mi Panel · MultiPerfil",
      title: "Hola {name}, gestiona todos tus perfiles desde una sola cuenta.",
      subtitle: "Una sola persona, una sola cuenta, múltiples oportunidades. Agrega un negocio, una fundación, un perfil profesional — cada uno es una tarjeta independiente en la red.",
      totalProfiles: "Perfiles",
      totalViews: "Vistas totales",
      totalClicks: "Clics totales",
      totalRatings: "Reseñas totales",
      profilesHeading: "Mis perfiles",
      addProfile: "Agregar nuevo perfil",
      editBtn: "Editar",
      viewBtn: "Ver público",
      confirmDelete: "¿Eliminar este perfil?",
      emptyTitle: "Aún no tienes perfiles",
      emptyBody: "Crea tu primer perfil — puede ser un negocio, una fundación, un perfil profesional u otro. Después podrás agregar más.",
      kindBusiness: "Negocio",
      kindVenture: "Emprendimiento",
      kindProfessional: "Profesional",
      kindNgo: "Fundación / ONG",
      kindChurch: "Iglesia",
      kindCommunityLeader: "Líder Comunitario",
      // Profile form
      formNewTitle: "Crear nuevo perfil",
      formEditTitle: "Editar perfil",
      formNewSub: "Elige el tipo que aplica y completa lo básico. Después puedes ajustar detalles.",
      stepKind: "Elige el tipo",
      stepDetails: "Datos del perfil",
      stepBrand: "Marca y redes (opcional)",
      kindHint: "Puedes tener varios perfiles de tipos distintos — por ejemplo, un negocio y un perfil profesional.",
      kindBusinessDesc: "Negocio establecido con clientes.",
      kindVentureDesc: "Idea en desarrollo, creciendo.",
      kindProfessionalDesc: "Profesional licenciado (médico, abogado, asesor).",
      kindNgoDesc: "ONG, fundación o cámara de comercio.",
      kindChurchDesc: "Iglesia u organización religiosa.",
      kindCommunityLeaderDesc: "Líder individual que sirve a la comunidad.",
      cancel: "Cancelar",
      save: "Guardar",
      saving: "Guardando…",
      back: "Atrás",
      next: "Siguiente",
      createBtn: "Crear perfil",
      updateBtn: "Actualizar perfil",
      savedToast: "Perfil guardado.",
      backToPanel: "Volver a mi panel",
      changeKind: "Cambiar",
      welcomeTitle: "¡Solo un paso más! 🎉",
      welcomeBody: "Tu cuenta ya está creada. Completa este formulario corto para publicar tu primer perfil y terminar tu registro.",
      catalogBtn: "Catálogo",
      agendaBtn: "Agenda",
      yourPlan: "Tu plan", profilesLabel: "perfiles", productsPerProfile: "productos por perfil", viewPlans: "Ver planes",
      profilesUsage: "Usas {used} de {max} perfiles", profilesRemaining: "Te queda(n) {n}", profilesFull: "Límite alcanzado — mejora tu plan para crear más",
    },
    plans: {
      eyebrow: "Membresías",
      title: "Elige el plan que se adapta a tu momento",
      subtitle: "Empieza gratis, sube de plan cuando crezcas. Cada plan desbloquea más perfiles, más productos y mejor visibilidad.",
      currentPlan: "Tu plan actual",
      contactAdmin: "Contacta a un administrador para mejorar tu plan",
      requestUpgrade: "Solicitar upgrade",
      sending: "Enviando…",
      requestSent: "Tu solicitud fue enviada. Te contactaremos pronto.",
    },
    adminPlans: {
      searchPh: "Buscar usuario por nombre o email…",
      empty: "No hay usuarios con el plan seleccionado.",
      thUser: "Usuario", thRole: "Rol", thPlan: "Plan",
    },
    profileCatalog: {
      eyebrow: "Catálogo del perfil",
      notYours: "Este perfil no es tuyo.",
      notFound: "Perfil no encontrado.",
    },
    profileAgenda: {
      eyebrow: "Mi agenda",
      onlyProfessional: "La agenda solo está disponible para perfiles profesionales.",
    },
    registerModal: {
      eyebrow: "Únete a la RED",
      title: "¿Cómo quieres unirte?",
      subtitle: "Elige la opción que mejor te describe. Podrás agregar más perfiles después.",
      footer: "¿Ya tienes cuenta?",
      footerLink: "Inicia sesión",
      options: {
        client: {
          title: "Miembro de la Comunidad",
          desc: "Busco servicios, profesionales o negocios en mi comunidad.",
        },
        business: {
          title: "Negocio o Emprendimiento",
          desc: "Tengo un negocio y quiero publicar mis productos o servicios.",
        },
        professional: {
          title: "Profesional Licenciado",
          desc: "Soy médico, abogado, coach o asesor. Quiero abrir mi agenda en línea.",
        },
        organization: {
          title: "Organización / Iglesia",
          desc: "ONG, fundación, iglesia o líder comunitario que sirve a la comunidad.",
        },
      },
    },
    registerAccount: {
      eyebrow: "Nuevo · Cuenta unificada",
      title: "Crea tu cuenta una sola vez. Agrega tantos perfiles como necesites.",
      subtitle: "Una sola cuenta para tu negocio, tu fundación, tu perfil profesional — gestiónalos todos desde un único panel.",
      cityHint: "Donde se concentra tu actividad (puedes cambiarla por perfil).",
      submit: "Crear mi cuenta",
      creating: "Creando cuenta…",
      afterHint: "Siguiente paso: elige el tipo de perfil que vas a crear (negocio, profesional, fundación, iglesia o líder comunitario).",
      navHint: "Cuenta unificada · Multi-perfil",
      proHint: "Registro como Profesional · RED Online",
      proHintAfter: "Justo después de este paso solo te pediremos los datos básicos de tu perfil profesional.",
      kindHint_business: "Registro como Negocio",
      kindHint_venture: "Registro como Emprendimiento",
      kindHint_professional: "Registro como Profesional · RED Online",
      kindHint_ngo: "Registro como ONG / Fundación",
      kindHint_church: "Registro como Iglesia",
      kindHint_community_leader: "Registro como Líder Comunitario",
      pickTitle: "¿Qué tipo de perfil quieres?",
      pickHint: "Elige uno para empezar. Podrás agregar más perfiles después.",
      pickRequired: "Por favor elige un tipo de perfil.",
      pick: {
        community: { label: "Comunidad", desc: "Solo miembro — explora la RED." },
        business: { label: "Negocio", desc: "Una tienda o empresa local." },
        venture: { label: "Emprendimiento", desc: "Un emprendimiento pequeño o en crecimiento." },
        professional: { label: "Profesional", desc: "Ofrece citas en RED Online." },
        ngo: { label: "ONG / Fundación", desc: "Una organización sin fines de lucro." },
        church: { label: "Iglesia", desc: "Una iglesia o ministerio." },
        community_leader: { label: "Líder Comunitario", desc: "Un representante de la comunidad." },
      },
    },
    registerChoice: {
      classicOr: "O usa el flujo clásico",
      trustNote: "Somos una comunidad de confianza. Los miembros se registran para que los negocios sepan quién los contacta.",
    },
    profileSwitcher: {
      eyebrow: "Perfil activo",
      subtitle: "Cambia el perfil que estás gestionando.",
      pick: "Elige un perfil",
      addProfile: "Agregar nuevo perfil",
      managePanel: "Gestionar todos los perfiles",
    },
    userMenu: {
      signedInAs: "Conectado como",
      noProfilesYet: "Aún sin perfiles",
      myPanel: "Mi panel",
    },
  },
};

export default dict;
